<template>
    <div>
      
  <!--  <b-row class="my-1" v-for="Input in Inputs" :key="Input">
      <b-col sm="3">  
        <label :for="`type-${Input}`"> {{ Input }}:</label>
      </b-col>
      <b-col sm="9">
        <b-form-input :v-model="`${Input}`"></b-form-input>
      </b-col>
    </b-row>   -->

     <!-- Se instancia el formulario de la ficha -->
<form @submit.prevent="handleSubmit" class="formFichas">
      <b-row class="my-1" >
        <b-col sm="3">
          <label> Biblioteca:</label>
        </b-col>
        <b-col sm="9">
          <v-select id="select"  :placeholder="placeSelect"
            v-model="BibliotecaSelect"
            :reduce="(option) => option.No"
            :options="bibliotecas"/>
        </b-col>
      </b-row> 
      <b-row class="my-1" >
      <b-col sm="3">
        <label> Libre:</label>
      </b-col>
      <b-col sm="9">
        <b-form-input id="Libre" v-model="Libre"></b-form-input>
      </b-col>
    </b-row>  
    <b-row class="my-1" >
      <b-col sm="3">
        <label> Titulo:</label>
      </b-col>
      <b-col sm="9">
        <b-form-input id="TitUlo" v-model="Titulo"></b-form-input>
      </b-col>
    </b-row>  
    <b-row class="my-1" >
      <b-col sm="3">
        <label> Autor:</label>
      </b-col>
      <b-col sm="9">
        <b-form-input id="Autor" v-model="Autor"></b-form-input>
      </b-col>
    </b-row>  
    
</form>

    <br>
    <b-row class="my-1">
       <b-col sm="3">
       </b-col> 
      <b-col sm="9">
        <!--href="#tableFicha"-->
           <b-button id="btnBuscar" block  v-on:click="cargarDatos"  type="submit" :disabled=btnBuscarDisable>  <b-icon icon="search"></b-icon> Buscar</b-button>
     </b-col> 

     <b-col>
        <ListaSelect :datosResult="datosBuscar" 
                     :busys="loading" />      
    </b-col>      
    </b-row>
     
  </div>
</template>

<script>
// import BtnClasic from '../components/BtnClasic.vue'
//import Select2 from '@/components/Select2.vue'
import 'vue-select/dist/vue-select.css';
import axios from "axios";
import ListaSelect from '@/components/ListaSelect'

export default {
    name: 'inputInicio',
    components:{
      // Select2, 
       ListaSelect
    },
    props: [],

    mounted (){
     axios.post('https://sacepb.uasnet.mx:8080/api.siabuc/biblioteca')
            .then(response => {
              this.bibliotecas = response.data.datos
            })
            .catch(e => {
              this.Error = e
            })
    },
    data(){
        return {
        datosBuscar: [],
        Libre: '',
        Titulo: '',
        Autor: '' ,
        Temas: '',
        BibliotecaSelect: 0,
        loading: false,
        Error: '',
        bibliotecas: [],
        placeSelect: 'Seleccionar biblioteca',
        }
    },
    computed:{
      selctBiblio: function(){
              if ( (this.BibliotecaSelect == 0 || this.BibliotecaSelect == null)){
               return 0
            }
            else 
               return this.BibliotecaSelect
        },

      btnBuscarDisable: function(){
          if ( this.Libre.trim() =='' && this.Titulo.trim() =='' && this.Autor.trim() =='' && this.selctBiblio == 0){
               return true 
            }
            else 
               return false
        }
    },
    methods: {
        cargarDatos(){
          var payload = {
            Libre: this.Libre,
            Titulo: this.Titulo,
            Autor: this.Autor,
            Biblioteca: this.selctBiblio
          };
          this.loading = true;
           axios.post('https://sacepb.uasnet.mx:8080/api.siabuc/ficha', payload)
            .then(response => {
              this.datosBuscar = response.data.datos
              this.loading = false
            })
            .catch(e => {
              this.Error = e
            })
        }
       
        },
}

</script>

<style scoped>
input {
  font-size: 1.5rem;
  
}
label{
   font-size: 1.9rem;
   text-shadow: 0 0 black;
}
#btnBuscar {
  background-image: linear-gradient(to left, #003595, #1D71B8);
  font-size: 1.5rem;
  width: 50% !important;
  align-content: center !important;
}
@media (max-width: 480px) {
  label{
    font-size: 1.4rem;
  }
  input {
  font-size: 1.3rem;
}
  #btnBuscar {
  margin-left: 25%;
  margin-right: 25%;
  border-radius: 6%;
  font-size: 1.2rem;
}


}

</style>